
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './first-cond-explanation';
const mainimage = '/Images/firstcondprod1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "grammar", subtype: "first-cond-prod" },
];

const FirstCondProd = () => (
  <GrammarPageLayout
    level="B1"
    title="First Cond Prod"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English First Conditional Grammar Practice"
    seoDescription="Advanced practice for first conditional structures with production exercises. B1 level."
    relatedCategory="grammar-exercises"
    relatedLevel="B1"
  />
);

export default FirstCondProd;

